import React from 'react';
import {
	SearchFilterExpandable,
	searchFilterExpandableClasses,
	type SearchFilterExpandableProps,
} from '@netx/core-components/SearchFilterExpandable';
import {useAssetViewsProvider} from '../../contexts';

export type AssetViewsTextFilterElement = HTMLDivElement;
export type AssetViewsTextFilterRef =
	React.ForwardedRef<AssetViewsTextFilterElement>;

export interface AssetViewsTextFilterProps extends SearchFilterExpandableProps {}

export const AssetViewsTextFilterPrimitive = React.forwardRef<
	AssetViewsTextFilterElement,
	AssetViewsTextFilterProps
>((props, ref) => {
	return <SearchFilterExpandable ref={ref} variant="outlined" {...props} />;
});

/**
 * `AssetViewsTextFilterContainer` is a higher-order component that wraps `AssetViewsTextFilter` with context and state management.
 */

export const AssetViewsTextFilter = AssetViewsTextFilterPrimitive as (
	props: AssetViewsTextFilterProps,
	ref: AssetViewsTextFilterRef,
) => JSX.Element;

export default AssetViewsTextFilter;

export type AssetViewsTextFilterContainerProps = Omit<
	AssetViewsTextFilterProps,
	'filterStr' | 'onFilter'
>;

export const AssetViewsTextFilterContainer = React.forwardRef<
	AssetViewsTextFilterElement,
	AssetViewsTextFilterContainerProps
>(({disabled, ...props}: AssetViewsTextFilterContainerProps, ref) => {
	const provider = useAssetViewsProvider();
	return (
		<AssetViewsTextFilter
			ref={ref}
			{...props}
			disabled={disabled || provider.noRecords || provider.loading}
			filterStr={provider.filter}
			onFilter={(filter) => {
				provider.setFilter(filter || '');
			}}
		/>
	);
}) as (
	props: AssetViewsTextFilterContainerProps,
	ref: AssetViewsTextFilterRef,
) => JSX.Element;
